export default class webglSet{
    constructor(kv){

        this.kv = kv;

    }

    /* ---------------------------------------------------

　　　-- webgl set

    --------------------------------------------------- */

    set(){

        TweenMax.to(this.kv.loader, 0.1, {
            display: 'none',
            opacity: 0
        });
        TweenMax.staggerTo(this.kv.copy, 0.6, {
            delay: 2.6,
            y: '0%',
            ease: this.kv.easeBack
        }, 0.08);
        TweenMax.to(this.kv.btn, 0.6, {
            delay: 2.9,
            opacity: 1,
            y: '0px',
            ease: this.kv.easeBack,
            onComplete:() => {
                document.querySelector('html').classList.remove('is-no-scroll');
            }
        });
        TweenMax.fromTo(this.kv.scrolldown, 0.6, {
            opacity:0,
            scale:0.8,
        },{
            delay: 2.9,
            opacity: 1,
            scale:1,
            ease: this.kv.easeBack,
        });

        if(Useragnt.mobile || Useragnt.tablet) {
            TweenMax.fromTo(this.kv.informationBtn, 0.6, {
                opacity:0,
                display:'none',
                scale:0.8,
            },{
                delay: 2.9,
                opacity: 1,
                display:'block',
                scale:1,
                ease: this.kv.easeBack,
            });
        }

    }


}